import { styled } from '@mui/material';
import TextField from '@mui/material/TextField';

interface InputProps {
  error: boolean;
  shadow: boolean;
}

export const Input = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'shadow' && prop !== 'error',
})<InputProps>`
  width: 60%;
  color: ${(props) => props.theme.palette.fixed.white};
  /* Glassmorphism */
  //background: transparent;
  border-radius: 8px;
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  //box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  //border: transparent;
  box-shadow: ${({ shadow }) =>
    shadow ? '0 8px 32px rgba(31, 38, 135, 0.37)' : undefined};

  /* Texto */
  //color: ${(props) => props.theme.palette.white.main};

  .MuiInputBase-input {
    //color: ${(props) => props.theme.palette.white.main};
    color: ${(props) => props.theme.palette.white['06']};
    font-weight: 100;
  }

  input::placeholder {
    color: ${(props) => props.theme.palette.white['06']};
    //opacity: 0.6;
  }

  /* Input base */
  .MuiOutlinedInput-root {
    border-radius: 8px;
    background: transparent;

    &:hover .MuiOutlinedInput-notchedOutline {
      //border-color: ${(props) => props.theme.palette.primary['02']};
    }

    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border: 1px solid ${(props) => props.theme.palette.primary['04']};
      background: transparent;
    }
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
    box-shadow: 0 0 0px 1000px transparent inset !important;
    -webkit-text-fill-color: ${(props) =>
      props.theme.palette.white['06']} !important;
    transition: background-color 5000s ease-in-out 0s;
  }

  .MuiOutlinedInput-notchedOutline {
    //border: 1px solid hsla(0, 100%, 50%, 0.2);
    border: ${({ error, theme }) =>
      error ? `1px solid ${theme.palette.status.offline}` : 'none'};
  }

  /* Label */
  .MuiInputLabel-shrink {
    //background-color: ${(props) => props.theme.palette.white['06']};
    background: transparent;
    &.Mui-focused {
      background: transparent;
      color: ${(props) => props.theme.palette.primary['02']};
    }
  }

  /* Helper text */
  .MuiFormHelperText-root {
    margin-left: 12px;
    font-size: 12px;
  }

  && {
    .MuiInputLabel-shrink {
      background-color: transparent !important;
      padding: 0 4px;
      border-radius: 4px;
    }

    .MuiInputLabel-root:not(.MuiInputLabel-shrink) {
      color: ${({ theme }) => theme.palette.white['06']};
      background-color: transparent;
      transition: all 0.2s ease;
      transform: translate(16px, 9px) scale(1);
    }

    /* Label normal, sem valor/foco (como placeholder) */
    .MuiInputLabel-root {
      color: ${({ theme }) => theme.palette.white['06']};
      background-color: transparent;
      transition: all 0.2s ease;
    }
  }

  /* Remover sublinhados padrão */
  &::before,
  &::after {
    display: none;
  }
`;
